import React from "react";
import DatePicker from "react-datepicker";
import { fr } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

// Custom CSS for French DatePicker
const customStyles = `
  .french-datepicker .react-datepicker__header {
    background-color: #f8f9fa;
    border-bottom: 1px solid #dee2e6;
  }
  
  .french-datepicker .react-datepicker__day-names {
    display: flex;
    justify-content: space-between;
    padding: 0 8px;
  }
  
  .french-datepicker .react-datepicker__day-name {
    width: 40px !important;
    height: 30px !important;
    line-height: 30px !important;
    text-align: center !important;
    font-size: 12px !important;
    font-weight: 600 !important;
    color: #495057 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
  }
  
  .french-datepicker .react-datepicker__month-dropdown-container,
  .french-datepicker .react-datepicker__year-dropdown-container {
    margin: 0 5px;
  }
  
  .french-datepicker .react-datepicker__month-select,
  .french-datepicker .react-datepicker__year-select {
    padding: 4px 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background-color: white;
    font-size: 14px;
  }
  
  .french-datepicker .react-datepicker__day {
    width: 40px !important;
    height: 40px !important;
    line-height: 40px !important;
    margin: 0 !important;
    border-radius: 50% !important;
    font-size: 14px !important;
  }
  
  .french-datepicker .react-datepicker__day:hover {
    background-color: #e9ecef !important;
  }
  
  .french-datepicker .react-datepicker__day--selected {
    background-color: #007bff !important;
    color: white !important;
  }
  
  .french-datepicker .react-datepicker__day--keyboard-selected {
    background-color: #007bff !important;
    color: white !important;
  }
  
  .french-datepicker .react-datepicker__day--outside-month {
    color: #6c757d !important;
  }
  
  .french-datepicker .react-datepicker__navigation {
    top: 10px;
  }
  
  .french-datepicker .react-datepicker__current-month {
    font-size: 16px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 10px;
  }
`;

// French locale configuration for react-datepicker
const frenchLocale = {
  ...fr,
  localize: {
    ...fr.localize,
    month: (n) => fr.localize.month(n),
    day: (n) => fr.localize.day(n),
  },
  formatLong: {
    ...fr.formatLong,
  },
};

// French month names
const frenchMonths = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

// French day names (shorter versions for better fit)
const frenchDays = [
  "Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"
];

// French short day names
const frenchShortDays = ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"];

const FrenchDatePicker = (props) => {
  // Inject custom styles
  React.useEffect(() => {
    const styleElement = document.createElement('style');
    styleElement.textContent = customStyles;
    document.head.appendChild(styleElement);
    
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  return (
    <DatePicker
      {...props}
      locale={frenchLocale}
      monthNames={frenchMonths}
      dayNames={frenchDays}
      dayNamesShort={frenchShortDays}
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      popperClassName="french-datepicker"
      calendarClassName="french-datepicker"
    />
  );
};

export default FrenchDatePicker;
